import React, { Fragment } from 'react';
import { func, string } from 'prop-types';
import Radium from 'radium';
import { UTLabel, WithLoading } from '@widergy/energy-ui';

import { appConfig, DOCUMENT } from 'config/customization';
import { message } from 'utils/stringUtils';

import OnlinePaymentPlaces from './components/OnlinePaymentPlaces';
import PaymentPlaces from './components/PaymentPlaces';
import AccountPaymentDocsForm from './components/AccountPaymentDocs';
import UserPaymentDocs from './components/UserPaymentDocs';
import { onlinePaymentPlaces, paymentPlaces } from './constants';
import stylesJS from './styles';
import styles from './styles.module.scss';

const PaymentsScene = ({
  documentType,
  documentNumber,
  handleSubmitUserPaymentDocs,
  handleSubmitAccountPaymentDocs,
  onGoToHome
}) => (
  <Fragment>
    <UTLabel className={styles.description}>
      {appConfig.payments.publicPayment
        ? message('PublicPayment:publicPaymentSubtitle')
        : message('PublicPayment:publicPaymentDocumentSubtitle')}
    </UTLabel>
    {appConfig.signInMethod === DOCUMENT && (
      <UserPaymentDocs
        documentType={documentType}
        documentNumber={documentNumber}
        onSubmit={handleSubmitUserPaymentDocs}
      />
    )}
    <AccountPaymentDocsForm onSubmit={handleSubmitAccountPaymentDocs} onGoToHome={onGoToHome} />
    {appConfig.showPaymentPlaces && (
      <div style={stylesJS.placesContainer}>
        <UTLabel bold large style={stylesJS.label}>
          {message('PublicPayment:authorizedPlaces')}
        </UTLabel>
        <div style={stylesJS.placesGroups}>
          <div style={[stylesJS.placeGroup, stylesJS.marginRight]}>
            <div style={stylesJS.placeSubtitle}>
              <UTLabel extrabold darkGray style={stylesJS.subtitle}>
                {message('PublicPayment:payOnline')}
              </UTLabel>
            </div>
            <OnlinePaymentPlaces places={onlinePaymentPlaces} />
          </div>
          <div style={[stylesJS.placeGroup, stylesJS.marginLeft]}>
            <div style={stylesJS.placeSubtitle}>
              <UTLabel extrabold darkGray>
                {message('PublicPayment:neighbourPlaces')}
              </UTLabel>
            </div>
            <PaymentPlaces places={paymentPlaces} />
          </div>
        </div>
      </div>
    )}
  </Fragment>
);

PaymentsScene.propTypes = {
  documentType: string.isRequired,
  documentNumber: string.isRequired,
  handleSubmitAccountPaymentDocs: func.isRequired,
  handleSubmitUserPaymentDocs: func.isRequired,
  onGoToHome: func.isRequired
};

export default WithLoading(props => props.loading)(Radium(PaymentsScene));
